import toastr from 'react-hot-toast';
import { useMutation } from 'react-query';
import { fetchWrapper } from 'utils/fetchWrapper';
import { SPARK_RESOURCE_TYPES } from 'constants/common';
import type { SingleResourceShareResponse } from 'types/Share/ResourceShares';

type MutationVariables = {
  id?: string;
};

export function useResendInvite(resourceShareID?: string | null | undefined) {
  const resendInvite = (variables: MutationVariables) => {
    const { id: _id } = variables;
    const id = _id || resourceShareID;

    if (!id) {
      return Promise.reject('Resource Share ID can not be null');
    }

    const url = `${SPARK_RESOURCE_TYPES.RESOURCE_SHARES}/${id}/ResendInvite`;

    const body = {
      data: {
        id: id,
        type: SPARK_RESOURCE_TYPES.RESOURCE_SHARES,
      },
    };
    return fetchWrapper<SingleResourceShareResponse>({
      url: url,
      method: 'POST',
      body,
    });
  };

  return useMutation(
    [`resendInvite-${SPARK_RESOURCE_TYPES.RESOURCE_SHARES}`, resourceShareID],
    resendInvite,
    {
      onError: (error) => {
        if (error instanceof Error) {
          toastr.error(`Failed to resend Invite: ${error.message}`);
        }
      },
      onSuccess: () => {
        toastr.success(`Invite Sent`);
      },
    }
  );
}
